module.exports = __webpack_public_path__ + "static/img/chargePage.4e8884d9.png";